import type { WorldLevel } from '@/queries/constants'
import WorldMemberQ from '@/queries/WorldMemberQ'
import WorldQ from '@/queries/WorldQ'
import { useQuery } from '@/client/context/query'
import { useUser } from '@/client/context/user'
import { SQL } from '@/client/query'

import { worldDetailsFromQuery } from '../../transforms/detailsFromQueries'
import type { WorldDetails } from '../../types'

export default function useMemberWorlds<K extends (keyof WorldDetails)[]>(
  fields: [...K],
  minLevel?: WorldLevel
): Pick<WorldDetails, K[number]>[] {
  const user = useUser()
  const query = useQuery()

  const worlds = query.many(
    WorldQ.where(
      {
        include: [
          { association: 'Course', required: false },
          {
            association: 'WorldMembers',
            required: true,
            where: SQL`${WorldMemberQ.user_id} = ${user.id} AND ${minLevel != null ? WorldMemberQ.isAtLeastLevel(minLevel) : WorldMemberQ.isAtLeastLevel('member')}`,
          },
        ],
        order: [[WorldMemberQ.position, 'asc']],
      },
      WorldQ.isUserMember(user.id)
    )
  )

  return worlds.map(world => worldDetailsFromQuery(fields, { world, userId: user.id }))
}
